import { Reservation } from '..';
import { ReservationsService } from '../reservation.service';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import { Component, OnInit, Input, EventEmitter, Output, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AlertService, ConstantService } from '@app/_services';
import * as moment from 'moment';
import { PrimeNGConfig } from 'primeng/api';

@Component({
    selector: 'app-reservations',
    templateUrl: './reservation.component.html',
    styleUrls: ['./reservation.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class ReservationsComponent implements OnInit {

	constructor(
		private primengConfig: PrimeNGConfig,
		private reservationService: ReservationsService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		public constantService: ConstantService,
		private formBuilder: UntypedFormBuilder,
		@Inject(MAT_DIALOG_DATA) data: any) {
		this.formTitle = data.title,
			this.reservation = data.reservation,
			this.statuses = reservationService.statuses;
			this.isFromTapeChart = data.isFromTapeChart;
	}

	@Input() reservation: Reservation;
	@Output() doAdd = new EventEmitter<any>();
	@Output() doUpdate = new EventEmitter<any>();
	@Output() doDelete = new EventEmitter<any>();

	// data
	reservationId: number;

	reservationStatuses: any = [];
	reservationTypes: any = [];

	// forms
	form1: UntypedFormGroup;
	formLoading = false;
	formAlert: String;
	formTitle: String;

	statuses: any;

	//Fetch reservation by Id if request is from TapeChart
	isFromTapeChart: any = false;

	validationMessages = {
		reservationId: [],
		externalSystemName: [],
		extReservationId: [],
		extConfirmationId: [],
		extHashId: [],
		numNightsToNextCheckIn: [],
		numNightsFromPrevCheckOut: [],
		qualityScore: [],
		checkInDate: [],
		checkOutDate: [],
		numNights: [],
		holdDate: [],
		quoteDate: [],
		saleDate: [],
		closeDate: [],
		cancelDate: [],
		reservationType: [],
		reservationStatus: [],
		paying: [],
		roomRatePN: [],
		roomRateTTL: [],
		lastname: [],
		firstname: [],
		email: [],
		phone: [],
		numAdults: [],
		numChildren: [],
		opsNotes: [],
	};

	ngOnInit() {
		this.primengConfig.ripple = true;
		this.reservationStatuses =  this.reservationService.reservationStatuses;
		this.reservationTypes =  this.reservationService.reservationTypes;
		this.formBuild();

		// if we were passed the whole reservation object
		if (this.reservation) {
			if(this.isFromTapeChart)
			{
				this.findReservationDetails(this.reservation.reservationId);
			}
			this.reservationId = this.reservation.reservationId;
			this.fixDates();
			this.form1.patchValue(this.reservation);
		}
	}

	findReservationDetails(reservationId)
	{
		try {
			console.log('findReservationDetails');
			this.formLoading = true;
			this.reservationService.findYieldMaxReservationById(reservationId)
				.subscribe(
					(res: any) => {
						console.log('property-add SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.reservation = res.data.reservation;
						this.fixDates();
						this.form1.patchValue(this.reservation);
					},
					(err: any) => {
						console.log('reservation-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
		}
	}

	onFormDelete() {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + this.reservationId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete()
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}

	formAdd() {
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			console.log('property-add post: ' + JSON.stringify(this.form1.value));
			this.formLoading = true;
			this.reservationService.add(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-add SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.reservation = res.data.reservation;
						this.doAdd.emit(this.reservation);
					},
					(err: any) => {
						console.log('reservation-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
		}
	}

	formUpdate() {
		console.log('reservation: ' + JSON.stringify(this.form1.value));
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			this.formLoading = true;

			this.reservationService.update(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-update SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.reservation = res.data.reservation;
						this.doUpdate.emit(this.reservation);
					},
					(err: any) => {
						console.log('property-update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	formDelete() {
		try {
			this.reservationService.delete(this.reservation.reservationId)
				.subscribe(
					(res: any) => {
						console.log('reservation-delete SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.doDelete.emit(this.reservation);
					},
					(err: any) => {
						console.log('reservation-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			this.alertService.error(error);
		}
	}

	formBuild() {
		this.form1 = this.formBuilder.group({
			reservationId: [],
			externalSystemName: [],
			extReservationId: [],
			extConfirmationId: [],
			extHashId: [],
			numNightsToNextCheckIn: [],
			numNightsFromPrevCheckOut: [],
			qualityScore: [],
			checkInDate: [],
			checkOutDate: [],
			numNights: [],
			holdDate: [],
			quoteDate: [],
			saleDate: [],
			closeDate: [],
			cancelDate: [],
			reservationType: [],
			reservationStatus: [],
			paying: [],
			roomRatePN: [],
			roomRateTTL: [],
			lastname: [],
			firstname: [],
			email: [],
			phone: [],
			numAdults: [],
			numChildren: [],
			opsNotes: [],
		});
	}

	fixDates() {
		// create date objects - why can't primeng do this?
		this.reservation.reservationDate = moment(this.reservation.reservationDate).toDate();
	}
}
